import React from 'react';

import { Divider, Skeleton, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PropsWithLoadingState } from '../../../utilities';
import { IListingItemProps, ListingItem } from '../../listing/ListingItem/ListingItem';
import { Carousel } from '../../Carousel';

export interface IProfileListingSectionProps {
    profileDisplayName: string;
    items: IListingItemProps[];
}

export const ProfileListingSection = ({ profileDisplayName, items, loading }: PropsWithLoadingState<IProfileListingSectionProps>) => {
    const { t } = useTranslation();

    if (loading) {
        return (
            <Stack direction={'column'}>
                <Skeleton variant={'text'} />
                <Skeleton variant={'rectangular'} height={50} />
            </Stack>
        )
    }

    if (!items.length) {
        return null;
    }

    return (
        <Stack direction={'column'}>
            <Divider>{t('user.profile.listingsSectionTitle', { name: profileDisplayName })}</Divider>
            <Carousel items={items.map((item, index) =>
                <ListingItem key={`listing-${index}`} {...item} />
            )} />
        </Stack>
    )
}